// Same rules as `isOrgLoginRedirectUbDomain` in `src/proxy.ts`, which is stencil-managed
// and not importable from client code. Keep both in sync with the cloudflare-workers list.
const CONSUMER_HOST_PROD = /^(www|aws-dr)\.udemy\.com$/;
const CONSUMER_HOST_DEV =
    /^(www\.(u\.)?udemy\.dev|(?!paulatest|learning)[\w]+\.u\.udemy\.dev|(www\.)?dev-ud\.com)$/;

export function isOrgHost(host: string | null | undefined): boolean {
    if (!host) {
        return false;
    }
    const hostname = host.split(':')[0].toLowerCase();
    if (CONSUMER_HOST_PROD.test(hostname) || CONSUMER_HOST_DEV.test(hostname)) {
        return false;
    }
    return hostname.endsWith('.udemy.com') || hostname.endsWith('.udemy.dev');
}
